// extracted by mini-css-extract-plugin
export default {"buttonContainer":"ButtonDownload_buttonContainer__llsck","buttonIcon":"ButtonDownload_buttonIcon__b5Zzd"};